<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <div class="search-card">
          <div class="search-header">
            <h3 class="search-title">
              <i class="el-icon-search"></i>
              搜索筛选
            </h3>
          </div>
          <div class="search-content">
            <el-form size="medium" :inline="true" :model="searchForm" class="search-form">
              <div class="form-row">
                <el-form-item label="姓名" class="form-item">
                  <el-input
                    v-model="searchForm.name"
                    placeholder="输入姓名"
                    clearable
                    prefix-icon="el-icon-user">
                  </el-input>
                </el-form-item>
                <el-form-item label="邮箱" class="form-item">
                  <el-input
                    v-model="searchForm.email"
                    placeholder="输入邮箱"
                    clearable
                    prefix-icon="el-icon-message">
                  </el-input>
                </el-form-item>
                <el-form-item label="电话" class="form-item">
                  <el-input
                    v-model="searchForm.phone"
                    placeholder="输入电话"
                    clearable
                    prefix-icon="el-icon-phone">
                  </el-input>
                </el-form-item>
                <el-form-item label="状态" class="form-item">
                  <el-select
                    v-model="searchForm.inquiry_status"
                    placeholder="选择状态"
                    clearable>
                    <el-option label="未读" value="0"></el-option>
                    <el-option label="已读" value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button type="primary" class="search-btn" @click="handleSearch">
                    <i class="el-icon-search"></i>
                    查询
                  </el-button>
                  <el-button class="reset-btn" @click="resetSearch">
                    <i class="el-icon-refresh-left"></i>
                    重置
                  </el-button>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>

        <div class="table-card">
          <div class="table-header">
            <h3 class="table-title">
              <i class="el-icon-chat-line-square"></i>
              咨询列表
            </h3>
            <div class="table-tools">
              <span class="data-count">共 {{pagingData.total}} 条记录</span>
            </div>
          </div>

          <ApeTable
            :data="list"
            :loading="loadingStatus"
            :pagingData="pagingData"
            ref="apeTable"
            highlight-current-row
            class="modern-table"
            @switchPaging="switchPaging">
            <el-table-column
              width="64"
              label="序号"
              align="center">
              <template slot-scope="scope">
                {{offset + scope.$index + 1}}
              </template>
            </el-table-column>

            <el-table-column label="联系人" min-width="160">
              <template slot-scope="scope">
                <div class="name-cell">
                  <div class="name-text">{{scope.row.name}}</div>
                  <div class="meta-text">{{scope.row.email}}</div>
                  <div class="meta-text">{{scope.row.phone}}</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="主题" min-width="160" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.subject || '-'}}
              </template>
            </el-table-column>

            <el-table-column label="留言" min-width="220" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.message}}
              </template>
            </el-table-column>

            <el-table-column label="来源环境" min-width="200">
              <template slot-scope="scope">
                <div class="env-cell">
                  <div class="env-ip">{{scope.row.client_ip || '-'}}</div>
                  <div class="env-meta">{{scope.row.browser || '-'}}</div>
                  <div class="env-meta">{{scope.row.os || '-'}} / {{scope.row.device || '-'}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="100" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.inquiry_status === '1' ? 'success' : 'warning'" size="small">
                  {{scope.row.inquiry_status === '1' ? '已读' : '未读'}}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column label="提交时间" width="170" align="center">
              <template slot-scope="scope">
                {{scope.row.created_at}}
              </template>
            </el-table-column>

            <el-table-column label="操作" width="180" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="viewDetail(scope.row)">查看</el-button>
                <el-popconfirm
                  title="确定删除这条咨询吗？"
                  confirm-button-text="删除"
                  cancel-button-text="取消"
                  @confirm="deleteButton(scope.row.id)">
                  <el-button slot="reference" size="mini" type="danger">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>

    <el-dialog
      :title="dialogData.title"
      :visible.sync="dialogData.visible"
      width="760px"
      :close-on-click-modal="false"
      @close="dialogClose">
      <div class="detail-body" v-loading="dialogData.loading">
        <div class="detail-row"><span class="label">姓名</span><span>{{detail.name}}</span></div>
        <div class="detail-row"><span class="label">电话</span><span>{{detail.phone}}</span></div>
        <div class="detail-row"><span class="label">邮箱</span><span>{{detail.email}}</span></div>
        <div class="detail-row"><span class="label">主题</span><span>{{detail.subject || '-'}}</span></div>
        <div class="detail-row"><span class="label">状态</span>
          <el-tag :type="detail.inquiry_status === '1' ? 'success' : 'warning'" size="small">
            {{detail.inquiry_status === '1' ? '已读' : '未读'}}
          </el-tag>
        </div>
        <div class="detail-row"><span class="label">时间</span><span>{{detail.created_at}}</span></div>
        <div class="detail-row"><span class="label">IP</span><span>{{detail.client_ip || '-'}}</span></div>
        <div class="detail-row"><span class="label">代理IP</span><span>{{detail.forwarded_for || '-'}}</span></div>
        <div class="detail-row"><span class="label">浏览器</span><span>{{detail.browser || '-'}}</span></div>
        <div class="detail-row"><span class="label">系统/设备</span><span>{{detail.os || '-'}} / {{detail.device || '-'}}</span></div>
        <div class="detail-row"><span class="label">语言</span><span>{{detail.language || '-'}}</span></div>
        <div class="detail-row"><span class="label">来源页</span><span>{{detail.referer || '-'}}</span></div>
        <div class="detail-row"><span class="label">提交页</span><span>{{detail.page_url || '-'}}</span></div>
        <div class="detail-row"><span class="label">分辨率</span><span>{{detail.screen || '-'}}</span></div>
        <div class="detail-row"><span class="label">时区</span><span>{{detail.timezone || '-'}}</span></div>
        <div class="detail-row"><span class="label">UA</span><span class="ua-text">{{detail.user_agent || '-'}}</span></div>
        <div class="detail-message">
          <div class="label">留言内容</div>
          <div class="message-box">{{detail.message}}</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-if="detail.inquiry_status !== '1'"
          type="primary"
          @click="markAsRead">
          标为已读
        </el-button>
        <el-button @click="dialogClose">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'

export default {
  components: {
    PageHeaderLayout,
    ApeTable
  },
  data() {
    return {
      loadingStatus: false,
      list: [],
      searchForm: {
        name: '',
        email: '',
        phone: '',
        inquiry_status: ''
      },
      searchCondition: {
        current_page: 1,
        page_size: 20,
        order_by: 'created_at desc',
        query: '',
        params: []
      },
      pagingData: {
        page_size: 20,
        current_page: 1,
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      offset: 0,
      dialogData: {
        visible: false,
        loading: false,
        title: '咨询详情'
      },
      detail: {}
    }
  },
  methods: {
    handleSearch() {
      this.pagingData.current_page = 1
      this.loadList()
    },
    resetSearch() {
      this.searchForm = {
        name: '',
        email: '',
        phone: '',
        inquiry_status: ''
      }
      this.pagingData.current_page = 1
      this.loadList()
    },
    async switchPaging() {
      await this.loadList()
    },
    setSearchCondition() {
      const pagingInfo = this.$refs['apeTable']
        ? this.$refs['apeTable'].getPagingInfo()
        : { page_size: this.pagingData.page_size, current_page: this.pagingData.current_page }
      this.searchCondition.page_size = pagingInfo.page_size
      this.searchCondition.current_page = pagingInfo.current_page
      this.offset = (pagingInfo.current_page - 1) * pagingInfo.page_size
      this.searchCondition.params = []
      this.searchCondition.query = ''
      if (this.searchForm.name) {
        this.appendQuery('INSTR(name,?)', this.searchForm.name)
      }
      if (this.searchForm.email) {
        this.appendQuery('INSTR(email,?)', this.searchForm.email)
      }
      if (this.searchForm.phone) {
        this.appendQuery('INSTR(phone,?)', this.searchForm.phone)
      }
      if (this.searchForm.inquiry_status !== '' && this.searchForm.inquiry_status != null) {
        this.appendQuery('inquiry_status=?', this.searchForm.inquiry_status)
      }
    },
    appendQuery(clause, value) {
      if (this.searchCondition.query) {
        this.searchCondition.query += ' and ' + clause
      } else {
        this.searchCondition.query = clause
      }
      this.searchCondition.params.push(value)
    },
    async loadList() {
      this.loadingStatus = true
      this.setSearchCondition()
      const res = await this.$api.post('/service/ola_app_inquiry/list', this.searchCondition)
      if (this.$apiSuccess(res)) {
        this.list = res.data.list || []
        this.pagingData.total = (res.data.page && res.data.page.total) || 0
      } else {
        this.$message.error(res.message || '加载失败')
      }
      this.loadingStatus = false
    },
    async viewDetail(row) {
      this.dialogData.visible = true
      this.dialogData.loading = true
      this.dialogData.title = '咨询详情'
      const res = await this.$api.post('/service/ola_app_inquiry/detail', { id: row.id })
      if (this.$apiSuccess(res)) {
        this.detail = res.data.detail || {}
        if (this.detail.inquiry_status !== '1') {
          await this.markAsRead(false)
        }
      } else {
        this.$message.error(res.message || '加载失败')
      }
      this.dialogData.loading = false
    },
    async markAsRead(showTip = true) {
      if (!this.detail.id) return
      const payload = Object.assign({}, this.detail, { inquiry_status: '1' })
      const res = await this.$api.post('/service/ola_app_inquiry/update', payload)
      if (this.$apiSuccess(res)) {
        this.detail.inquiry_status = '1'
        if (showTip) {
          this.$message.success('已标为已读')
        }
        this.loadList()
      } else if (showTip) {
        this.$message.error(res.message || '操作失败')
      }
    },
    async deleteButton(id) {
      const res = await this.$api.post('/service/ola_app_inquiry/delete', { id })
      if (this.$apiSuccess(res)) {
        this.$message.success('删除成功!')
        this.loadList()
      } else {
        this.$message.error(res.message || '删除失败!')
      }
    },
    dialogClose() {
      this.dialogData.visible = false
      this.detail = {}
    }
  },
  mounted() {
    this.loadList()
  }
}
</script>

<style lang="stylus" scoped>
.main-page-content
  padding 0

.search-card, .table-card
  background #fff
  border-radius 12px
  padding 24px
  margin-bottom 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0

.search-header, .table-header
  margin-bottom 16px
  display flex
  justify-content space-between
  align-items center

.search-title, .table-title
  margin 0
  font-size 16px
  color #303133

.data-count
  color #909399
  font-size 13px

.name-cell
  .name-text
    font-weight 600
    color #303133
  .meta-text
    font-size 12px
    color #909399
    margin-top 2px

.env-cell
  .env-ip
    font-weight 600
    color #303133
  .env-meta
    font-size 12px
    color #909399
    margin-top 2px

.ua-text
  word-break break-all
  font-size 12px
  color #606266

.detail-body
  .detail-row
    display flex
    align-items center
    margin-bottom 12px
    line-height 1.6
    .label
      width 72px
      color #909399
      flex-shrink 0
  .detail-message
    margin-top 8px
    .label
      color #909399
      margin-bottom 8px
    .message-box
      background #f5f7fa
      border-radius 8px
      padding 12px 14px
      white-space pre-wrap
      line-height 1.6
      color #303133
</style>
